export const environment = {
  useMock: false,
  delayForMockResolveReject: 1000,
  api_endpoint: 'https://dev.api.remitcircle.com',
  // api_endpoint: 'http://localhost:8082/',
  organization_id: `9dd6298b-e1aa-4364-9437-a950784e88b2`,
  support_email: 'admin@remitcircle.com',
  admin_email: 'admin@remitcircle.com',
};
